export default function RSSIcon() {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="ic rss">
                <path
                    id="Union"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 6C6.70718 6 8.39765 6.33625 9.97488 6.98957C11.5521 7.64288 12.9852 8.60045 14.1924 9.80761C15.3996 11.0148 16.3571 12.4479 17.0104 14.0251C17.6637 15.6023 18 17.2928 18 19H20C20 17.0302 19.612 15.0796 18.8582 13.2597C18.1044 11.4399 16.9995 9.78628 15.6066 8.3934C14.2137 7.00052 12.5601 5.89563 10.7403 5.14181C8.92037 4.38799 6.96983 4 5 4V6ZM7.67878 12.5328C6.8295 12.1811 5.91925 12 5 12V10C6.1819 10 7.35222 10.2328 8.44415 10.6851C9.53608 11.1374 10.5282 11.8003 11.364 12.636C12.1997 13.4718 12.8626 14.4639 13.3149 15.5558C13.7672 16.6478 14 17.8181 14 19H12C12 18.0807 11.8189 17.1705 11.4672 16.3212C11.1154 15.4719 10.5998 14.7003 9.94975 14.0503C9.29974 13.4002 8.52806 12.8846 7.67878 12.5328ZM8 17.5C8 18.3284 7.32843 19 6.5 19C5.67157 19 5 18.3284 5 17.5C5 16.6716 5.67157 16 6.5 16C7.32843 16 8 16.6716 8 17.5Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
}
